import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/home/index'
import Layout from '@/components/layout/layout'
import RecruitList from '@/components/recruit/list'
import RecruitDetail from '@/components/recruit/detail'
import ResumeLayout from '@/components/resume/layout'
import Resume from '@/components/resume/index'
import ResumeSuccess from '@/components/resume/success'
import ResumeError from '@/components/resume/error'
import RecruitLayout from '@/components/recruit/layout'
import Announcement from '@/components/announcement/index'
import CompanyProfile from '@/components/companyprofile/index'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: Layout,
      redirect: '/home',
      children: [
        {
          path: 'announcement',
          name: 'announcement',
          component: Announcement,
          meta: {
            index: '3'
          }
        },
        {
          path: 'companyProfile',
          name: 'companyProfile',
          component: CompanyProfile,
          meta: {
            index: '4'
          }
        },
        {
          path: 'home',
          name: 'home',
          component: Home,
          meta: {
            index: '1'
          }
        },
        {
          path: '/resume',
          name: 'resume',
          component: ResumeLayout,
          children: [
            {
              path: 'detail/:id',
              name: 'ResumeDetail',
              component: Resume,
              meta: {
                index: '2'
              }
            },
            {
              path: 'success',
              name: 'ResumeSuccess',
              component: ResumeSuccess,
              meta: {
                index: '2'
              }
            },
            {
              path: 'error/:msg',
              name: 'ResumeError',
              component: ResumeError,
              meta: {
                index: '2'
              }
            }
          ]
        },
        {
          path: '/recruit',
          name: 'recruit',
          component: RecruitLayout,
          meta: {
            index: '2'
          },
          children: [
            {
              path: '',
              name: 'RecruitList',
              component: RecruitList,
              meta: {
                index: '2'
              }
            },
            {
              path: ':id',
              name: 'RecruitDetail',
              component: RecruitDetail,
              meta: {
                index: '2'
              }
            }
          ]
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js